import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import { isKoreaService } from 'constants/domains/domains';

export const getRecommendedBeautyOutputGroupNames = () => {
  const groupNames:string[] = [
    GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT,
    GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_TEXTURE,
    GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_TRY,
  ];
  if (isKoreaService()) {
    groupNames.push(GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.REELS_PRODUCT_BEFORE_AFTER);
  }
  return groupNames;
};